import React, { useState, useEffect, useId, forwardRef, useRef } from 'react';
import { motion, AnimatePresence, useIsPresent} from 'framer-motion';



export const ExclamationIcon = ({className}) => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" className={`${className} fill-skeptic-charcoal dark:fill-skeptic-foreground-dark`} viewBox="0 0 22 23" fill="none">
    <path d="M10.9997 16.9529C11.2036 16.9529 11.3693 16.8894 11.4968 16.7623C11.6241 16.635 11.6878 16.4694 11.6878 16.2654C11.6878 16.0615 11.6243 15.8958 11.4971 15.7683C11.3698 15.641 11.2042 15.5773 11.0003 15.5773C10.7964 15.5773 10.6307 15.6409 10.5032 15.768C10.3759 15.8953 10.3122 16.0609 10.3122 16.2648C10.3122 16.4687 10.3758 16.6345 10.5029 16.762C10.6302 16.8893 10.7958 16.9529 10.9997 16.9529ZM10.5126 12.9746H11.5469V5.51753H10.5126V12.9746ZM11.0095 22.5C9.48149 22.5 8.05221 22.2114 6.72161 21.6341C5.39082 21.0568 4.22675 20.27 3.22942 19.2736C2.23208 18.2771 1.44456 17.1137 0.866861 15.7833C0.288954 14.4527 0 13.0229 0 11.4939C0 9.97528 0.288648 8.54752 0.865944 7.21061C1.44324 5.8737 2.23005 4.70994 3.22636 3.71933C4.22288 2.72872 5.38633 1.94456 6.71672 1.36686C8.04732 0.788954 9.47711 0.5 11.0061 0.5C12.5247 0.5 13.9525 0.788649 15.2894 1.36595C16.6263 1.94324 17.7901 2.72669 18.7807 3.71628C19.7713 4.70587 20.5554 5.86963 21.1331 7.20756C21.711 8.54528 22 9.97294 22 11.4905C22 13.0185 21.7114 14.4478 21.1341 15.7784C20.5568 17.1092 19.7733 18.2719 18.7837 19.2666C17.7941 20.2615 16.6304 21.0491 15.2924 21.6295C13.9547 22.2098 12.5271 22.5 11.0095 22.5ZM11.0101 21.4657C13.779 21.4657 16.1306 20.4979 18.0648 18.5623C19.9987 16.6265 20.9657 14.269 20.9657 11.4899C20.9657 8.72097 19.9999 6.36942 18.0684 4.43525C16.1369 2.50129 13.7808 1.5343 11 1.5343C8.22759 1.5343 5.87349 2.50006 3.93769 4.43158C2.0021 6.3631 1.03431 8.71924 1.03431 11.5C1.03431 14.2724 2.0021 16.6265 3.93769 18.5623C5.87349 20.4979 8.23095 21.4657 11.0101 21.4657Z" />
    </svg>
)
}

export const ListIcon = ({className}) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" className={`${className} fill-skeptic-charcoal dark:fill-skeptic-foreground-dark`} viewBox="0 0 24 25" fill="none">
          <mask id="mask0_2852_7956" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x={0} y={0} width={24} height={25}>
            <rect y="0.744141" width={24} height={24} fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_2852_7956)">
            <path d="M10.6 17.3441L17.65 10.2941L16.25 8.89414L10.6 14.5441L7.75 11.6941L6.35 13.0941L10.6 17.3441ZM12 22.7441C10.6167 22.7441 9.31667 22.4816 8.1 21.9566C6.88333 21.4316 5.825 20.7191 4.925 19.8191C4.025 18.9191 3.3125 17.8608 2.7875 16.6441C2.2625 15.4275 2 14.1275 2 12.7441C2 11.3608 2.2625 10.0608 2.7875 8.84414C3.3125 7.62747 4.025 6.56914 4.925 5.66914C5.825 4.76914 6.88333 4.05664 8.1 3.53164C9.31667 3.00664 10.6167 2.74414 12 2.74414C13.3833 2.74414 14.6833 3.00664 15.9 3.53164C17.1167 4.05664 18.175 4.76914 19.075 5.66914C19.975 6.56914 20.6875 7.62747 21.2125 8.84414C21.7375 10.0608 22 11.3608 22 12.7441C22 14.1275 21.7375 15.4275 21.2125 16.6441C20.6875 17.8608 19.975 18.9191 19.075 19.8191C18.175 20.7191 17.1167 21.4316 15.9 21.9566C14.6833 22.4816 13.3833 22.7441 12 22.7441ZM12 20.7441C14.2333 20.7441 16.125 19.9691 17.675 18.4191C19.225 16.8691 20 14.9775 20 12.7441C20 10.5108 19.225 8.61914 17.675 7.06914C16.125 5.51914 14.2333 4.74414 12 4.74414C9.76667 4.74414 7.875 5.51914 6.325 7.06914C4.775 8.61914 4 10.5108 4 12.7441C4 14.9775 4.775 16.8691 6.325 18.4191C7.875 19.9691 9.76667 20.7441 12 20.7441Z" fill="" />
          </g>
        </svg>
    )
}

export const SkepticLogo = () => {
    return (      
      <svg xmlns="http://www.w3.org/2000/svg" className="" fill="none" viewBox="0 0 633 130">
        <g clipPath="url(#clip0_1_3)">
          <mask style={{maskType: 'luminance'}} id="mask0_1_3" width={633} height={130} x={0} y={0} maskUnits="userSpaceOnUse">
            <path fill="#fff" d="M632.406 0H0v130h632.406V0z" />
          </mask>
          <g mask="url(#mask0_1_3)">
            <path className='fill-skeptic-charcoal dark:fill-skeptic-foreground-dark' d="M28.285 96.586c1.483 2.898 3.453 5.247 5.912 7.048 2.458 1.802 5.337 3.133 8.652 4.003a40.333 40.333 0 0 0 10.28 1.305c2.4 0 4.97-.199 7.71-.609 2.742-.409 5.312-1.191 7.71-2.349 2.4-1.157 4.396-2.758 5.998-4.786 1.602-2.027 2.398-4.612 2.398-7.744 0-3.368-1.053-6.091-3.17-8.18-2.116-2.088-4.883-3.828-8.31-5.22-3.426-1.393-7.307-2.61-11.65-3.655a312.494 312.494 0 0 1-13.193-3.48 116.19 116.19 0 0 1-13.364-4.264c-4.344-1.68-8.225-3.855-11.651-6.526-3.427-2.672-6.194-6.005-8.31-10.007-2.116-4.003-3.17-8.85-3.17-14.532 0-6.378 1.345-11.92 4.026-16.62 2.682-4.698 6.194-8.614 10.538-11.746 4.343-3.133 9.252-5.456 14.735-6.962C38.908.757 44.39 0 49.874 0c6.4 0 12.533.722 18.419 2.175C74.178 3.63 79.404 5.978 83.97 9.224c4.566 3.245 8.199 7.396 10.88 12.443 2.681 5.046 4.026 11.164 4.026 18.36H72.833c-.231-3.716-1.002-6.787-2.313-9.224-1.31-2.436-3.058-4.35-5.226-5.743-2.167-1.392-4.651-2.375-7.453-2.958-2.801-.583-5.851-.87-9.166-.87-2.168 0-4.344.235-6.511.696a17.313 17.313 0 0 0-5.911 2.436 14.886 14.886 0 0 0-4.37 4.35c-1.139 1.741-1.713 3.943-1.713 6.614 0 2.436.454 4.412 1.37 5.917.918 1.505 2.717 2.898 5.398 4.177 2.681 1.279 6.39 2.55 11.137 3.828 4.737 1.28 10.94 2.898 18.59 4.873 2.287.461 5.457 1.305 9.51 2.524 4.051 1.218 8.078 3.158 12.079 5.83 4 2.67 7.453 6.239 10.365 10.702 2.913 4.464 4.369 10.181 4.369 17.142 0 5.682-1.088 10.964-3.254 15.837-2.168 4.873-5.398 9.076-9.681 12.617-4.284 3.541-9.595 6.291-15.935 8.266-6.34 1.976-13.681 2.959-22.017 2.959-6.742 0-13.278-.845-19.618-2.524-6.34-1.679-11.933-4.324-16.79-7.918-4.858-3.593-8.713-8.179-11.566-13.748-2.861-5.569-4.232-12.182-4.12-19.84h26.051c0 4.177.745 7.719 2.227 10.616zM135.536 2.958v51.513l47.795-51.513h33.582L169.11 52.034l52.43 75.181h-33.755l-36.836-55.863-15.422 15.836v40.027h-26.899V2.958h26.908zM313.547 2.958V25.93h-64.594v33.588h59.283v21.231h-59.283v23.494h65.966v22.972h-92.865V2.958h91.493zM510.414 2.958v124.257h-26.9V2.958h26.9zM602.251 36.111a27.437 27.437 0 0 0-5.997-6.874c-2.398-1.975-5.115-3.507-8.138-4.612-3.033-1.105-6.194-1.653-9.51-1.653-6.057 0-11.196 1.192-15.42 3.567-4.223 2.376-7.65 5.57-10.28 9.572-2.631 4.003-4.541 8.554-5.74 13.661-1.199 5.108-1.799 10.381-1.799 15.837 0 5.456.6 10.294 1.799 15.228 1.199 4.933 3.109 9.371 5.74 13.313 2.63 3.941 6.057 7.109 10.28 9.484 4.224 2.376 9.363 3.568 15.42 3.568 8.225 0 14.649-2.549 19.276-7.657 4.626-5.108 7.453-11.834 8.481-20.188h26.043c-.685 7.77-2.458 14.793-5.311 21.058-2.853 6.265-6.623 11.599-11.308 16.01-4.686 4.412-10.169 7.771-16.449 10.094-6.279 2.324-13.192 3.481-20.732 3.481-9.363 0-17.793-1.653-25.272-4.96-7.479-3.306-13.793-7.857-18.932-13.661-5.141-5.804-9.082-12.617-11.823-20.449-2.741-7.831-4.112-16.271-4.112-25.32 0-9.05 1.371-17.9 4.112-25.844 2.741-7.945 6.682-14.88 11.823-20.797 5.139-5.917 11.453-10.555 18.932-13.922C560.813 1.679 569.243 0 578.606 0c6.743 0 13.108.983 19.105 2.958 5.996 1.976 11.367 4.847 16.105 8.615 4.738 3.768 8.652 8.44 11.737 14.01 3.084 5.568 5.028 11.946 5.826 19.143h-26.044c-.454-3.133-1.482-6.005-3.084-8.615z" />
            <path className='fill-skeptic-primary' d="M349.699 104.242h-26.9v22.972h26.9v-22.972zM417.976 28.018c-1.541-4.76-4-8.988-7.367-12.704-3.367-3.715-7.736-6.7-13.107-8.962-5.371-2.263-11.882-3.394-19.532-3.394h-55.171v31.673h26.9V24.19h20.903c3.084 0 6.057.235 8.909.696 2.853.461 5.372 1.366 7.539 2.697 2.168 1.332 3.916 3.22 5.226 5.656 1.311 2.437 1.971 5.63 1.971 9.572 0 3.942-.66 7.135-1.971 9.572-1.319 2.436-3.058 4.324-5.226 5.655-2.167 1.332-4.686 2.237-7.539 2.698a55.777 55.777 0 0 1-8.909.696l-18.761.174h-29.042V82.49h29.898l25.273.174c7.65 0 14.161-1.132 19.532-3.394 5.371-2.262 9.74-5.247 13.107-8.962a34.504 34.504 0 0 0 7.367-12.792 47.907 47.907 0 0 0 2.314-14.705c0-4.986-.771-10.033-2.314-14.793z" />
            <path className='fill-skeptic-charcoal dark:fill-skeptic-foreground-dark' d="M410.815 2.958c4.086 2.428 7.47 5.508 10.134 9.232 2.99 4.177 5.174 8.946 6.537 14.297 1.37 5.36 2.056 10.903 2.056 16.646s-.686 11.138-2.056 16.55c-1.371 5.421-3.547 10.224-6.537 14.401a32.41 32.41 0 0 1-4.771 5.308v47.814h26.899V25.93h36.667V2.958h-68.929z" />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1_3">
            <path fill="#fff" d="M0 0h632.406v130H0z" />
          </clipPath>
        </defs>
      </svg>
    );
}

export const SkeletonCard = ({className}) => {
    return(
        <article className={`${className} w-full bg-skeptic-background dark:bg-skeptic-background-dark border dark:border-white border-opacity-10 border-black dark:border-opacity-10 p-10 rounded-md h-screen`}>
            <div className="skp_skeleton flex flex-col w-full justify-between h-full gap-3">
                <div className="h-6 w-3/4 animate-pulse rounded-sm bg-skeptic-gray dark:bg-skeptic-gray-dark" aria-hidden="true"></div>

                <div className='flex justify-center my-8 gap-3'>
                   <div className="h-12 w-1/3 animate-pulse rounded-sm bg-skeptic-gray dark:bg-skeptic-gray-dark" aria-hidden="true"></div>
                   <div className="h-8 w-1/4 animate-pulse rounded-sm bg-skeptic-gray dark:bg-skeptic-gray-dark self-end" aria-hidden="true"></div>
                </div>

                <div className="h-3 w-full animate-pulse rounded-sm bg-skeptic-gray dark:bg-skeptic-gray-dark" aria-hidden="true"></div>
                <div className="h-3 w-full animate-pulse rounded-sm bg-skeptic-gray dark:bg-skeptic-gray-dark" aria-hidden="true"></div>
                <div className="h-3 w-full animate-pulse rounded-sm bg-skeptic-gray dark:bg-skeptic-gray-dark" aria-hidden="true"></div>
                <div className="h-3 w-full animate-pulse rounded-sm bg-skeptic-gray dark:bg-skeptic-gray-dark" aria-hidden="true"></div>
                <div className="h-3 w-3/4 animate-pulse rounded-sm bg-skeptic-gray dark:bg-skeptic-gray-dark" aria-hidden="true"></div>
                <div className="h-3 w-1/3  animate-pulse rounded-sm bg-skeptic-gray dark:bg-skeptic-gray-dark" aria-hidden="true"></div>

                
                <div className='w-full flex justify-center mt-3'>
                    <div className="h-11 w-full animate-pulse rounded-sm bg-skeptic-gray dark:bg-skeptic-gray-dark mt-6" aria-hidden="true"></div>
                </div>
                
                <span className="sr-only">loading</span>
            </div>
        </article>
    )
}

export const UserAccountScreenSkeleton = () => {
  return(
    <>
    <div className="flex items-center gap-3">
	      <div className="siz bg-skeptic-gray dark:bg-skeptic-gray-dark" aria-hidden="true"></div>
	      <div className="flex w-52 flex-col gap-3">
		      <div className="h-2.5 w-full animate-pulse rounded-md bg-skeptic-gray dark:bg-skeptic-gray-dark" aria-hidden="true"></div>
		      <div className="h-6 w-3/4 animate-pulse rounded-md bg-skeptic-gray dark:bg-skeptic-gray-dark" aria-hidden="true"></div>
          <div className="h-2.5 w-1/2 animate-pulse rounded-md bg-skeptic-gray dark:bg-skeptic-gray-dark" aria-hidden="true"></div>
	      </div>
	      <span className="sr-only">loading</span>
    </div>
    <div className="flex flex-col gap-3 mt-7">
        <div className="h-2.5 w-full animate-pulse rounded-md bg-skeptic-gray dark:bg-skeptic-gray-dark" aria-hidden="true"></div>
        <div className="h-2.5 w-full animate-pulse rounded-md bg-skeptic-gray dark:bg-skeptic-gray-dark" aria-hidden="true"></div>
        <div className="h-2.5 w-full animate-pulse rounded-md bg-skeptic-gray dark:bg-skeptic-gray-dark" aria-hidden="true"></div>
        <div className="h-2.5 w-1/2 animate-pulse rounded-md bg-skeptic-gray dark:bg-skeptic-gray-dark" aria-hidden="true"></div>
    </div>
    </>
  )
}

export const Loader = () => {
    return(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" className="size-6 ml-2 fill-black motion-safe:animate-spin">
      <path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25" />
      <path d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z" />
    </svg>
    )
}

export const Button = ({className, text='default', state='default', onClick}) => {
    return(
        <div className={`${state === 'default' ? 'group' : ''} flex w-full`}>
        <button onClick={onClick} disabled={state === "disabled"} className={`${className} skeptic_btn skeptic_btn_outline py-3 group-hover:border-skeptic-primary group-hover:bg-skeptic-primary`}>
             <span className="group-hover:text-skeptic-background">{text}</span>
             {state === 'loading' && (<Loader/>)}
       </button>
       </div> 
    )
}

export const ActiveBadge = ({className}) => {
  return(
      <div className={`${className} skeptic_btn bg-[#00A233] max-h-[2.53rem] cursor-default`}>
           <span className="!text-skeptic-background dark:!text-skeptic-background">Active</span>
     </div>
  )
}




export const Toggle = ({ idx, checked, toggleHandle, error_message }) => {
  const [isPending, setIsPending] = useState(false);

  const checkboxHandler = async event => {
      const toggleState = event.target.checked;
      setIsPending(true); // Show loading/disable interaction

      // Pass control back to parent
      await toggleHandle(idx, toggleState);
      setIsPending(false); // Re-enable interaction
  };

  return (
      <div className="flex items-center gap-3">
          <label htmlFor={idx} className="skp_switch">
              <input
                  id={idx}
                  type="checkbox"
                  checked={checked}
                  onChange={checkboxHandler}
                  disabled={isPending} // Prevent interaction during pending state
              />
              <span className="skp_slider skp_round"></span>
          </label>
          <div className="flex flex-col">
              <span className="text-sm uppercase text-[#3F3F3] dark:text-skeptic-silver">
                  {checked ? 'Newsletter Enabled' : 'Newsletter Disabled'}
              </span>
              {error_message && (
                  <small className="text-red-500 text-xs mt-px">{error_message}</small>
              )}
          </div>
      </div>
  );
};

export const EmailFormField = forwardRef((props, ref) => {
    const someID = useId();
    const [errorMessage, setErrorMessage] = useState('');

    const handleInputEvent = (e) => {
        if(e.target.value.length === 0) return;            
        if(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(e.target.value)){
            props.handleButton(true, e.target.value);
            setErrorMessage('');
            
        }else{
            props.handleButton(false, e.target.value);
            setErrorMessage('Invalid email address.');            
        }        
    }

    return(
        <div className='w-full flex flex-col'>
            <div className="flex flex-col w-full">
                <label htmlFor={someID} className="contact_form_label">Email</label>
                <input 
                id={someID}
                disabled={props.disabled} 
                onChange={handleInputEvent} 
                ref={ref}
                defaultValue={props.value}
                name="email" type="email" className="contact_form" placeholder="Jamie@example.com" autoComplete="email"/>
                <span className="form_underline"></span>
            </div> 
            <div>
                <small className="text-red-500 text-xs px-4 pt-1">{errorMessage}</small>
            </div>
        </div>
    )
})



export const AlertMessage = ({ show, message_body = {type: 'info', title: 'Alert Title', text: 'Alert text body', duration: 10000}, handleAlertVisibility } ) => {
    const visible = show;
    const message = message_body; //{type: 'info', title: 'Alert Title', text: 'Alert text body', duration: 40000}

    const closeTimeout = useRef(null);

    
    let bg_color = '';
    let border_color = '';
    let icon_color = '';
    let svg_icon = '';
    let text_color = 'black';


    switch(message.type){
        case 'info':
            text_color = 'text-sky-500';
            bg_color = 'bg-sky-500/15';
            border_color = 'border-sky-500/25';
            icon_color = 'bg-sky-500/15 text-sky-500';
            svg_icon = (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="size-6" aria-hidden="true">
                <path fillRule="evenodd" d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z" clipRule="evenodd" />
              </svg>);
            break;

        case 'success':
            text_color = 'text-green-500';
            bg_color = 'bg-green-500/15';
            border_color = 'border-green-500/25';
            icon_color = 'bg-green-500/15 text-green-500';
            svg_icon = (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="size-6" aria-hidden="true">
                 <path fillRule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z" clipRule="evenodd" />
                 </svg>);
            break;  
            
        case 'danger':
            text_color = 'text-red-500';
            bg_color = 'bg-red-500/15';
            border_color = 'border-red-500/25';
            icon_color = 'bg-red-500/15 text-red-500';
            svg_icon = (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="size-6" aria-hidden="true">
                <path fillRule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.28 7.22a.75.75 0 0 0-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 1 0 1.06 1.06L10 11.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L11.06 10l1.72-1.72a.75.75 0 0 0-1.06-1.06L10 8.94 8.28 7.22Z" clipRule="evenodd" />
                </svg>);
            break;

          case 'warn':
            text_color = 'text-amber-500';
            bg_color = 'bg-amber-500/15';
            border_color = 'border-amber-500/25';
            icon_color = 'bg-amber-500/15 text-amber-500';
            svg_icon = (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-6" aria-hidden="true">
              <path fillRule="evenodd" d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-8-5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 10 5Zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" clip-rule="evenodd" />
              </svg>);
            break;

        default:
            bg_color = '';
            border_color = '';
            icon_color = '';
            svg_icon = null;
            text_color = 'red';
    }


    const slideVariants = {
        hidden: { y: "-100%", x:"-50%", opacity: 0 }, // Starting position (hidden above the screen)
        visible: { y: "0%", x:"-50%" ,opacity: 1 },   // Final position (fully visible)
        exit: { y: "-100%", x:"-50%", opacity: 0 }    // Exit position (sliding back up)
      };

    useEffect(() => {
        if (visible) {
            closeTimeout.current = setTimeout(() => {
                handleAlertVisibility(false);
            }, message.duration);
        }
    }, [visible, message.duration]);

    const handleClose = () => {
        clearTimeout(closeTimeout);
        handleAlertVisibility(false);
    }

    return(
        <>
        {visible && (
        <motion.div
        initial="hidden"
        animate="visible"
        exit="exit"
        variants={slideVariants}
        className={`${border_color} absolute top-5 left-1/2 -translate-x-1/2 z-[9999] max-w-[380px] w-full overflow-hidden rounded-md border bg-white text-neutral-600`} role="alert">
          <div className={`${bg_color} flex w-full items-center gap-2 p-4`}>
            <div className={`${icon_color} rounded-full p-1" aria-hidden="true`}>
                {svg_icon}
            </div>
            <div className="ml-2">
              <h3 className={`${text_color} text-sm font-semibold`}>{message.title}</h3>
              <p className="text-xs font-medium sm:text-sm">{message.text}</p>
            </div>
            <button onClick={handleClose} type="button" className="ml-auto" aria-label="dismiss alert">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" stroke="currentColor" fill="none" strokeWidth="2.5" className="w-4 h-4 shrink-0">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </motion.div>
        )}
        </>
    )
}

export const StaticAlert = ({className, title, message}) => {
  return(
      <div className={`${className} relative w-full overflow-hidden max-w-xl rounded-md border border-red-500 border-opacity-15 bg-white text-neutral-600 dark:bg-neutral-950 dark:text-neutral-300`} role="alert">
          <div className="flex w-full items-center gap-2 bg-red-500/10 p-4">
              <div className="bg-red-500/15 text-red-500 rounded-full p-1" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="size-6" aria-hidden="true">
                      <path fillRule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.28 7.22a.75.75 0 0 0-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 1 0 1.06 1.06L10 11.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L11.06 10l1.72-1.72a.75.75 0 0 0-1.06-1.06L10 8.94 8.28 7.22Z" clipRule="evenodd" />
                  </svg>
              </div>
              <div className="ml-2">
              <h3 className="text-sm font-semibold text-red-500">{title}</h3>
              <p className="text-xs font-medium sm:text-sm">{message}</p>
              </div>
          </div>
      </div>
  )
}

export const CloseIcon = ({className}) => {
  const uniqueId = useId();
  return(
    <svg xmlns="http://www.w3.org/2000/svg" className={`${className} fill-[#1C1B1F] dark:fill-skeptic-foreground-dark`} viewBox="0 0 40 40" fill="none">
      <mask id={`mask_${uniqueId}`} style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x={0} y={0} width={40} height={40}>
      <rect width={40} height={40} fill="#D9D9D9" />
    </mask>
    <g mask={`url(#mask_${uniqueId})`}>
      <path d="M10.4715 31.4725L8.52734 29.5283L18.0548 20.0004L8.52734 10.4725L10.4715 8.52832L19.9994 18.0558L29.5273 8.52832L31.4715 10.4725L21.944 20.0004L31.4715 29.5283L29.5273 31.4725L19.9994 21.945L10.4715 31.4725Z" fill="" />
    </g>
</svg>
  )
}

export const BackArrow = ({className}) => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" className={`${className} fill-[#1C1B1F] dark:fill-skeptic-foreground-dark`} viewBox="0 0 16 28" fill="none">
      <path d="M13.6497 27.3332L0.316406 13.9998L13.6497 0.666504L15.6831 2.72217L4.40541 13.9998L15.6831 25.2775L13.6497 27.3332Z" fill="" />
    </svg>
  )
}

export function UserAvatar({className, remoteImageUrl }) {
  const localImage = '/assets/img/avatar.jpg'; // Local placeholder image
  const [src, setSrc] = useState(localImage); // Set initial src to local image
  const [isLoaded, setIsLoaded] = useState(false); // Track remote image load status

  useEffect(() => {
    // Create a new Image object to preload the remote image
    if(remoteImageUrl){
      let change_blank_to_anon_avatar = remoteImageUrl.replace('d=blank', 'd=mp'); //change blank default image to anon avatar
      const img = new Image();
      img.src = change_blank_to_anon_avatar;
  
      img.onload = () => {
        setSrc(change_blank_to_anon_avatar); // Set src to remote image once it's loaded
        setIsLoaded(true);
      };
    }

  }, [remoteImageUrl]);

  return (
    <figure className="flex flex-col justify-center items-center">
      <img
        className={`${className} aspect-square rounded-full overflow-hidden border border-black border-opacity-5`}
        src={src}
        alt="User Avatar"
      />
    </figure>
  );
}


